import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';

const MissionSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const reduce = useReducedMotion();

  // Fortschritt über die gesamte Sichtbarkeit der Sektion (unten rein bis oben raus). Vorher "start start" bis
  // "end end": Weil die Sektion niedriger als das Fenster ist, war dieser Bereich fast null und das Bild sprang.
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"]
  });

  // Bild ist oben und unten 12 % größer als der Rahmen, der Versatz bleibt darin, es entstehen keine Lücken
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['-8%', '8%']);
  // Zoom: beim Runterscrollen wächst das Haus, beim Hochscrollen wird es wieder kleiner
  const scale = useTransform(scrollYProgress, [0, 1], reduce ? [1, 1] : [1, 1.2]);

  return (
    <section
      ref={sectionRef}
      className="bg-black text-white relative overflow-hidden min-h-[90vh]"
    >
      {/* Background text */}
      <div className="absolute inset-x-0 top-0 flex flex-col items-center justify-start opacity-[0.05] pointer-events-none overflow-hidden pt-10">
        <span className="text-[15vw] font-black whitespace-nowrap select-none text-white leading-none">MISSION</span>
        <span className="text-[15vw] font-black whitespace-nowrap select-none text-white leading-none">MISSION</span>
        <span className="text-[15vw] font-black whitespace-nowrap select-none text-white leading-none">MISSION</span>
      </div>
      
      
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 items-center">
          {/* Left side - Building Image with Parallax */}
          <div className="relative h-[90vh] md:h-[90vh] overflow-hidden rounded">
            <motion.div
              className="absolute inset-x-0 -inset-y-[12%]"
              style={{ y, scale, willChange: 'transform' }}
            >
              <div className="w-full h-full relative">
                <img 
                  src="/parallaxgebaeude.avif"
                  alt="Modern architecture" 
                  className="w-full h-full object-cover min-w-full min-h-full"
                />
              </div>
            </motion.div>
          </div>
          
          {/* Right side - Mission content */}
          <div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Unsere Mission</h2>
              <p className="text-gray-300 text-lg mb-6 leading-relaxed">
                Investiere in Morgen, baue auf Sicherheit. Bei YADE Home verbinden wir zukunftsorientiertes
                Denken mit solider Wertsteigerung. Wir schaffen nicht nur Immobilien, wir entwickeln
                nachhaltige Investitionen, die Generationen überdauern und kontinuierlich an Wert gewinnen.
              </p>
              <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                Unsere Mission ist es, Ihnen die Sicherheit zu geben, die Sie für langfristige Investments
                benötigen. Mit durchdachter Standortwahl, erstklassiger Bauqualität und zukunftssicheren
                Konzepten machen wir Ihre Immobilie zur wertvollen Anlage für morgen.
              </p>
              
              {/* Unterschrift: nur Name und Rolle */}
              <div className="border-t border-white/15 pt-6">
                <p className="text-lg font-semibold">Deniz Adigüzel</p>
                <p className="text-sm text-gray-400">Geschäftsführer, YADE Home GmbH</p>
              </div>
            </motion.div>
          </div>
        </div>
      
    </section>
  );
};

export default MissionSection;
